import { initialState } from './initialState';
import * as types from './types';

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case types.SET_IS_LOADING:
      return {
        ...state,
        isLoading: state.isLoading + 1,
      };
    case types.SET_IS_NOT_LOADING:
      return {
        ...state,
        isLoading: state.isLoading > 0 ? state.isLoading - 1 : 0,
      };
    case types.SHOW_MODAL:
      return {
        ...state,
        modal: {
          showModal: true,
          title: payload.title,
          content: payload.content,
          link: payload.link,
          options: payload.options,
          Component: payload.Component,
        },
      };
    case types.HIDE_MODAL:
      return {
        ...state,
        modal: { ...initialState.modal },
      };
    case types.SHOW_AUTH_SUCCESS:
      return {
        ...state,
        showAuthSuccess: payload.value,
        isLoading: 0,
      };
    case types.SET_IS_DASHBOARD_LOADED:
      return {
        ...state,
        isDashboardLoaded: true,
      };
    case types.SET_AUTH_ERROR:
      return {
        ...state,
        authError: payload.error,
      };
    default:
      return state;
  }
};

export default reducer;
